__turbopack_context__.v({
  "glow": "tradingJournal-module-scss-module__OL1I7W__glow",
  "journal-breathe": "tradingJournal-module-scss-module__OL1I7W__journal-breathe",
  "scene": "tradingJournal-module-scss-module__OL1I7W__scene",
});
